import { createFileRoute } from '@tanstack/react-router'

import { CheckoutComplete } from '~/boundedContext/subscription/components/checkout-complete'

import { checkoutCompleteSearchSchema } from './-schemas/complete-schema'

export const Route = createFileRoute('/subscription/checkout/complete')({
  component: CheckoutComplete,
  validateSearch: search => checkoutCompleteSearchSchema.parse(search),
})
